export default __webpack_public_path__ + "static/double-the-donation-logo-73ac61c3b25bb0b1ade09fe75d4a11b6.png";